import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Mahtab Care</h3>
          <p>Licensed home daycare providing nurturing, educational care in a safe home environment. Part of the CWELCC program for quality child care.</p>
          <div className="footer-social">
            <a href="#" className="social-link">📧</a>
            <a href="#" className="social-link">📱</a>
            <a href="#" className="social-link">📍</a>
          </div>
        </div>
        
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li><a href="#services">Full Day Daycare</a></li>
            <li><a href="#services">Before & After School</a></li>
            <li><a href="#services">Half-Day Care</a></li>
            <li><a href="#services">CWELCC Program</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#facilities">Our Facilities</a></li>
            <li><a href="#contact">Contact</a></li>
            <li><a href="#visit">Schedule Visit</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>📍 Bradford West Gwillimbury</p>
          <p>📱 (647) 527-4552</p>
          <p>📧 mahtabshirdelan@gmail.com</p>
          <p>⏰ Available for visits anytime</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 Mahtab Care. Licensed Home Daycare. All rights reserved.</p>
        <p>CWELCC Program Participant</p>
      </div>
    </footer>
  );
}

export default Footer;